<template>
  <section :id="data?.blockId ?? null" :data-index="index" :data-block="data.__component" class="container mx-auto mt-24 md:mt-32 relative">
    <div class="max-md:hidden md:absolute top-0 right-8">
      <svg xmlns="http://www.w3.org/2000/svg" width="120" height="80" viewBox="0 0 120 80" fill="none">
        <path d="M30.4762 40.0002C30.4762 23.1686 16.8315 9.52393 0 9.52393" stroke="#070A26" stroke-width="19.0476"/>
        <path d="M79.9999 9.52378C63.1684 9.52378 49.5237 23.1684 49.5237 40" stroke="#070A26" stroke-width="19.0476"/>
        <path d="M80.0001 70.4762C96.8316 70.4762 110.476 56.8316 110.476 40" stroke="#070A26" stroke-width="19.0476"/>
      </svg>
    </div>
    <div class="max-w-md">
      <span v-if="data.preTitle" class="inline-block font-semibold mb-3" :style="`color: ${COLORS[data.preTitleColor as keyof typeof COLORS]}`">{{data.preTitle}}</span>
      <component :is="data.titleLevel || 'h2'" class="font-medium text-2xl md:text-3.5xl mb-4 md:mb-6 text-balance">{{ data.title }}</component>
      <div v-if="data.lead" class="prose">
        <MarkdownRenderer :markdown="data.lead" />
      </div>
    </div>
    <div class="mt-8 grid gap-4 md:gap-6 md:grid-cols-3">
      <div v-for="card in data.cards" class="rounded-xl overflow-hidden relative flex flex-col justify-stretch border border-gray">
        <div v-if="card.href">
          <a v-if="isExternal(card.href)" :href="card.href" class="absolute inset-0 z-10">
            <span class="sr-only">{{ card.title }}</span>
          </a>
          <NuxtLink v-else :to="card.href" class="absolute inset-0 z-10">
            <span class="sr-only">{{ card.title }}</span>
          </NuxtLink>
        </div>
        <div class="shrink-0 h-52 w-full relative">
          <NuxtPicture v-if="card.image?.data?.attributes.hash"
                       sizes="100vw sm:220px md:400px"
                       loading="lazy"
                       :src="card.image?.data?.attributes.hash"
                       :alt="card.image?.data?.attributes.alternativeText || ''"
                       :imgAttrs="{
                          class:'absolute inset-0 h-full w-full object-cover rounded-tr-xl rounded-tl-xl',
                          
                       }"
          />
        </div>
        <div class="h-full p-6">
          <h3 class="font-medium text-balance">{{ card.title }}</h3>
          <div class="text-sm mt-2 text-dark-grey" v-if="card.lead"><MarkdownRenderer :markdown="card.lead" /></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import MarkdownRenderer from '../components/MarkDown.vue';
  import { COLORS } from "~/utils/colors";

  const props = defineProps<{
    data: any,
    index: any
  }>();

  const isExternal = (url) => {
    return /^https?:\/\//.test(url);
  };
</script>
